<script lang="ts" setup>
import Button from "@/shared/components/Button/Button.vue";
import Form from "@/shared/components/Form/Form.vue";
import PasswordField from "@/shared/components/PasswordField/PasswordField.vue";
import Title from "@/shared/components/Title/Title.vue";
import { usePasswordFormFields } from "./usePasswordFormFields.composable";

withDefaults(
  defineProps<{
    isLoading?: boolean;
  }>(),
  {
    isLoading: false,
  },
);

const emit = defineEmits<{
  (e: "set-password", value: string): void;
}>();

const {
  possiblePasswordErrors,
  password: { value: password, errors: passwordErrors, meta: passwordMeta },
  handleSubmit,
} = usePasswordFormFields();

const onSubmit = handleSubmit(() => {
  emit("set-password", password.value);
});
</script>

<template>
  <div class="password-form">
    <Title
      size="l"
      :text="$t('registration.user.setPassword.title')"
    />
    <Form @submit="onSubmit">
      <template #default>
        <PasswordField
          v-model="password"
          :errors="passwordErrors"
          :possible-errors="possiblePasswordErrors"
          show-rules
          :show-as-validated="passwordMeta.validated"
          :label="$t('shared.term.password.default')"
        />
      </template>
      <template #actions>
        <Button
          type="submit"
          :caption="$t('registration.shared.action.setPassword')"
          :is-loading="isLoading"
          class="password-form--submit-button"
        />
      </template>
    </Form>
  </div>
</template>

<style scoped>
@import "PasswordForm.css";
</style>
